(ns common.schema.entities.workspace.kyc.templates.capman.board-member
  (:require
   [common.schema.entities.workspace.kyc.questions.questions-registry :as questions-registry]))

(def ^:private role-options
  [{:key :board-member
    :translations {:en "Board member"
                   :fi "Hallituksen jäsen"}}
   {:key :chair-of-the-board
    :translations {:en "Chair of the board"
                   :fi "Hallituksen puheenjohtaja"}}
   {:key :vice-chair-of-the-board
    :translations {:en "Vice chair of the board"
                   :fi "Hallituksen varapuheenjohtaja"}}
   {:key :deputy-board-member
    :translations {:en "Deputy board member"
                   :fi "Hallituksen varajäsen"}}])

(def schema
  {:kyc-template/template-name
   "Board members"
   :kyc-template/kyc-form-preface
   {:translations {:en "Board members"
                   :fi "Hallituksen jäsenet"}}

   :kyc-board-member.group/basic-information
   {:ord          1.0
    :translations {:en "Basic information"
                   :fi "Perustiedot"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-board-member/first-name]
                    [:kyc-board-member/middle-names]
                    [:kyc-board-member/last-name]
                    [:kyc-board-member/role
                     {:options role-options}]
                    [:kyc-board-member/dob]
                    [:kyc-board-member/nationalities]])}})
